/* unplugin-vue-components disabled */import { render } from "./Register.vue?vue&type=template&id=04f6b0e8&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=04f6b0e8&scoped=true&lang=css"
import "./Register.vue?vue&type=style&index=1&id=04f6b0e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f6b0e8"]])

export default __exports__